import React, { useContext } from 'react';
import { BaseInfoContext } from '@/context/BaseInfoContext';
import { User } from '@/models/user';

type Props = {
  children: React.ReactNode;
  userInfo?: User;
};

const RechargeOptionalWrapper: React.FC<Props> = ({ children, userInfo }: Props) => {
  const [
    {
      poiConfig: {
        rechargeConfig: { enabled },
      },
    },
  ] = useContext(BaseInfoContext);
  if (enabled || (userInfo && !isNaN(userInfo.balance))) {
    return <>{children}</>;
  }
  return null;
};

export default RechargeOptionalWrapper;
